import { useEffect, useState } from "react";
import { friendlyError } from "../../lib/errorMap";

const EVENT = "chat:show-error";

interface ErrorPayload {
  message: string;
  id: number;
}

export function showError(err: unknown): void {
  window.dispatchEvent(
    new CustomEvent<ErrorPayload>(EVENT, {
      detail: { message: friendlyError(err), id: Date.now() + Math.random() },
    }),
  );
}

export default function ErrorToast() {
  const [items, setItems] = useState<ErrorPayload[]>([]);

  useEffect(() => {
    const handler = (e: Event) => {
      const payload = (e as CustomEvent<ErrorPayload>).detail;
      setItems((prev) => [...prev, payload]);
      window.setTimeout(() => {
        setItems((prev) => prev.filter((p) => p.id !== payload.id));
      }, 5000);
    };
    window.addEventListener(EVENT, handler);
    return () => window.removeEventListener(EVENT, handler);
  }, []);

  if (!items.length) return null;
  return (
    <div className="fixed bottom-4 right-4 z-50 flex flex-col gap-2 pointer-events-none">
      {items.map((it) => (
        <div
          key={it.id}
          className="pointer-events-auto rounded-md bg-background border border-border text-foreground px-4 py-3 shadow-lg max-w-sm animate-fade-in"
        >
          {it.message}
        </div>
      ))}
    </div>
  );
}
